<!--  -->
<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="title">小程序名称</span>
        <el-input
          v-model="parameter.account_name"
          style="width: 200px;"
          placeholder="请输入内容"
        />
      </div>
      <div class="item">
        <span class="title">小程序app_id</span>
        <el-input
          v-model="parameter.app_id"
          style="width: 200px;"
          placeholder="请输入内容"
        />
      </div>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
      <el-button
        type="success"
        icon="el-icon-news"
        @click="getURLData"
      >授权</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="account_name"
          label="小程序名称"
          align="center"
        />
        <el-table-column
          prop="app_id"
          label="小程序app_id"
          align="center"
        />

        <el-table-column
          prop="balance"
          label="广告金(元)"
          align="center"
        />

        <el-table-column
          prop="created_at"
          label="授权时间"
          align="center"
        />
        <el-table-column
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="warning"
              @click="setMoney(scope.row)"
            >转出</el-button>
            <el-button
              type="primary"
              @click="moneyHisLis(scope.row)"
            >转出记录</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="授权"
      :visible.sync="dialogVisible"
      :show="true"
      width="1000px"
      @close="closeDialog"
      @confirm="closeDialog"
    >
      <iframe
        v-if="iframeURL === null ? false : true"
        width="960"
        height="600"
        marginwidth="0"
        marginheight="0"
        frameborder="0"
        scrolling="no"
        :src="iframeURL"
      />
    </el-dialog>
    <el-dialog
      title="转出广告金"
      :visible.sync="set_visible"
      width="600px"
    >
      <el-form label-width="100px">
        <el-form-item label="转出广告主">
          <el-input
            v-model="account_id"
            placeholder="请输入广告主id"
            style="width: 300px"
          />
        </el-form-item>
        <el-form-item label="转出金额">
          <el-input
            v-model="amt"
            placeholder="请输入金额"
            :precision="2"
            style="width: 300px"
            @blur="changeMoney"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button
          type="success"
          :loading="set_mon_load"
          @click="commitSetMoney"
        >确定</el-button>
        <el-button
          type="info"
          @click="set_visible = false"
        >取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="广告金转出记录"
      :visible.sync="amt_visible"
      width="1000px"
    >
      <el-table :data="amt_data">
        <el-table-column
          prop="app_id"
          label="小程序id"
          align="center"
        />
        <el-table-column
          prop="amt"
          label="转出广告金(元)"
          align="center"
        />
        <el-table-column
          prop="balance"
          label="广告金余额(元)"
          align="center"
        />
        <el-table-column
          prop="account_id"
          label="广告主id"
          align="center"
        />
        <el-table-column
          prop="account_name"
          label="广告主名称"
          align="center"
        />
        <el-table-column
          prop="created_at"
          label="转出时间"
          align="center"
        />
      </el-table>
      <pagination-right
        :total="amt_total"
        @size-change="amtFetchPageSize"
        @current-change="amtFetchCurrentPage"
      />
    </el-dialog>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

  </div>
</template>

<script>
import { mini_programTransfer, miniprogramindex, programmanageminiprogramofficial, transferLog } from '@/api/hugeAdvertGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      tableData: [],
      total: null,
      parameter: {
        page: 1,
        page_size: 10,
        app_id: '',
        account_name: ''
      },
      iframeURL: null,
      dialogVisible: false,
      set_visible: false,
      amt: 0,
      account_id: null,
      is_app_id: null,
      set_mon_load: false,
      amt_visible: false,
      amtpt: {
        page: 1,
        page_size: 10,
        app_id: this.is_app_id
      },
      amt_total: 0,
      amt_data: null,
      loading: false
    }
  },
  watch: {
    dialogVisible(newValue, oldValue) {
      if (!newValue) {
        this.iframeURL = null
      }
    }
  },
  created() {
    this.list()
  },
  mounted() {},
  methods: {
    // 跳转到授权页面
    getURLData() {
      this.dialogVisible = true
      programmanageminiprogramofficial().then(res => {
        console.log('res', res)
        this.iframeURL = res.data.url
        // window.open(res.data)
      })
    },
    // 关闭iframe
    closeDialog() {
      this.dialogVisible = false
      this.iframeURL = null
    },
    async list() {
      this.loading = true
      const data = await miniprogramindex(this.parameter)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data)
    },
    fetchPageSize(s) {
      this.parameter.page_size = s
      this.list()
    },
    amtFetchPageSize(s) {
      this.amtpt.page_size = s
      this.amtList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.list()
    },
    amtFetchCurrentPage(s) {
      this.amtpt.page = s
      this.amtList()
    },
    // 搜索
    search() {
      this.parameter.page = 1
      this.list()
    },

    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10,
        app_id: '',
        account_name: ''
      }
      this.list()
    },
    setMoney(val) {
      this.set_visible = true
      console.log(val)
      this.is_app_id = val.app_id
    },
    moneyHisLis(val) {
      this.amtpt.app_id = val.app_id
      this.amt_visible = true
      this.amtList()
      console.log(val)
    },
    amtList() {
      transferLog(this.amtpt).then(res => {
        console.log(res)
        this.amt_data = res.data.list
        this.amt_total = res.data.total
      })
    },
    commitSetMoney() {
      if (this.amt === '0.00' || !this.account_id) {
        return this.$message.error('请正确填写内容')
      }
      this.$confirm('确认转出' + this.amt + '到' + this.account_id + '吗', '确认转出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          mini_programTransfer({
            amt: this.amt,
            account_id: this.account_id,
            app_id: this.is_app_id
          })
            .then(res => {
              console.log(res)
              if (res.code === 0) {
                this.$message.success('成功')
                this.is_app_id = null
                this.set_visible = false
                this.set_mon_load = false
              }
            })
            .catch(err => {
              console.log(err)
              this.set_mon_load = false
            })
        })
        .catch(() => {
          console.log(22)
        })
    },
    changeMoney() {
      console.log(this.amt)
      this.amt = Number(this.amt).toFixed(2)
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>
<style scoped lang="less">
.selectionArea {
  display: flex;
}

.content {
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .item_title {
      display: inline-block;
      width: 100px;
    }
    .item_input {
      width: 200px;
    }
  }
}

.item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.title {
  display: inline-block;
  margin-right: 10px;
}
</style>
